// assets/stock-delay.js
(function (root) {
  if (root.themeStockDelay) {
    return;
  }

  function delayState(variant, requestedQty) {
    if (!variant || !variant.available || variant.inventory_management !== 'shopify') {
      return 'none';
    }
    if (variant.local_stock === null || variant.local_stock === undefined) {
      return 'none';
    }
    const localStock = Number(variant.local_stock);
    const qty = parseInt(requestedQty, 10);
    if (!Number.isFinite(localStock) || !Number.isFinite(qty)) {
      return 'none';
    }
    const wanted = Math.max(1, qty);
    if (localStock >= wanted) {
      return 'none';
    }
    return localStock <= 0 ? 'full' : 'partial';
  }

  // Mirrors snippets/lead-time-state.liquid: any quantity beyond local stock waits
  // for the central warehouse, so the whole line gets the long lead time.
  function leadTime(variant, requestedQty) {
    return delayState(variant, requestedQty) === 'none' ? 0 : 1;
  }

  root.themeStockDelay = { delayState: delayState, leadTime: leadTime };
})(window);
